const module = { name: 'movie/shared/castModal', exports: {} }; const exports = module.exports;



import { fd_url_manager as links } from 'require-core';



import { Fandango_adobeLaunch as Fandango_adobeLaunch_EventTypes_track } from 'require-global';

const { EventTypes, track } = Fandango_adobeLaunch_EventTypes_track;


import { Fandango_debugLog as debugLog } from 'require-core';



import { Fandango_Dialog as Dialog } from 'require-global';



const DefaultSelectors = Object.freeze({
    CAST_LINKS: '.js-cast-carousel-item',
    MODAL: '#person-overview-modal',
    MODAL_CONTENT: '#person-overview-modal-content',
    MODAL_CLOSE: '#person-overview-modal .js-modal-close-btn',
})
function renderModalError(container) {
    container.innerHTML = '<div class="content"><p class="dark__text">Sorry — we couldn’t load this person right now.</p></div>';
}
async function loadModalContent(personId, container) {
    if (!personId) {
        renderModalError(container);
        return;
    }
    try {
        const res = await fetch(links.personOverviewModal({ id: personId }));
        if (!res.ok) {
            throw new Error(`bad status: ${res.status}`);
        }
        container.innerHTML = await res.text();
    }
    catch (err) {
        debugLog.error(`${module.name} modal fetch failed`, err);
        renderModalError(container);
    }
}
function onCastClick(opts, e) {
    const { modalSelector, contentSelector } = opts;
    track({
        event: EventTypes.PERFORMER_CLICK,
        performerName: this.dataset.name || '',
        performerID: this.dataset.id || '',
    });
    if (this.getAttribute('aria-disabled') === 'true') {
        e.preventDefault();
        return;
    }
    const modal = document.querySelector(modalSelector);
    const content = document.querySelector(contentSelector);
    if (!modal || !content) {
        return;
    }
    e.preventDefault();
    const dialog = new Dialog(modalSelector);
    dialog.open();
    loadModalContent(this.dataset.id, content);
}
function attach(opts) {
    opts = opts || {};
    const root = opts.root || document;
    const closeBtn = document.querySelector(DefaultSelectors.MODAL_CLOSE);
    if (closeBtn && closeBtn.dataset.castModalCloseBound !== 'true') {
        closeBtn.dataset.castModalCloseBound = 'true';
        const dialog = new Dialog(DefaultSelectors.MODAL);
        closeBtn.addEventListener('click', () => dialog.close());
    }
    if (!root || !root.querySelectorAll) {
        return;
    }
}
module.exports = {
    attach,
    loadModalContent,
    renderModalError,
};
export default module.exports;